import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import TableSellDeliveryNotesRefund from '../../../../../../../specificComponents/sells/TableSellDeliveryNoteRefund'
import NullComponent from '../../../../../../../baseComponents/NullComponent'
import { Link } from 'react-router-dom'
import { ButtonSecondary } from '../../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import locations from '../../../../../../../utils/globals/locations'
import PermissionChecker from '../../../../../../../baseComponents/PermissionChecker'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'

interface SellDeliveryNotesRefundProps extends ComponentWithPermissions { }

const SellDeliveryNotesRefund: React.FC<SellDeliveryNotesRefundProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('deliveryNotesRefund', 'Devolución de albaranes'),
        newText: '',
    }

    return (
        <BaseScreenTable TableComponent={TableSellDeliveryNotesRefund} CreateModalComponent={NullComponent} pageData={pageData} userPermissions={userPermissions} RightHeader={<GenerateMultiDeliveryNoteRefundButton/>} />
    )
}


const GenerateMultiDeliveryNoteRefundButton = () => {
    return (
        <PermissionChecker userPermissions={getUserPermissions('sell.refundDeliveryNote')} permission={'create'}>
            <Link to={locations.sellDeliveryNoteRefundMulti + '/main'}>
                <ButtonSecondary className='mr-10'>
                    <TwinTrans transKey='generateMultiDeliveryNoteRefund'> Generar devolución de albarán múltiple</TwinTrans>
                </ButtonSecondary>
            </Link>
        </PermissionChecker>
    )
}

export default SellDeliveryNotesRefund